<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      @click="toggleDialogVisible(true)"
    >
      添加公告
    </el-button>
    <el-dialog
      title="添加公告"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="140px"
        class="announcement-form"
      >
        <el-form-item
          label="分类："
          prop="categoryId"
          :rules="[{ required: true, message: '分类不能为空' }]"
        >
          <el-select v-model="form.categoryId" placeholder="请选择">
            <el-option
              v-for="item in categoryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="语言类型："
          prop="language"
          :rules="[{ required: true, message: '语言类型不能为空' }]"
        >
          <el-select v-model="form.language" placeholder="请选择">
            <el-option
              v-for="item in languageList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="标题"
          prop="title"
          :rules="[{ required: true, message: '标题不能为空' }]"
        >
          <el-input
            type="text"
            v-model="form.title"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="content"
          label="内容"
          :rules="[{ required: true, message: '内容不能为空' }]"
        >
          <editor v-model="form.content" class="editor"></editor>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toggleDialogVisible(false)">取消</el-button>
        <el-button type="primary" @click="save('form')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from 'components/editor';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'CreateAnnouncement',
  components: {
    Editor
  },
  data() {
    return {
      dialogVisible: false,
      form: {}
    };
  },
  computed: {
    ...mapState('announcement', ['languageList']),
    ...mapGetters('announcement', ['categoryList'])
  },
  methods: {
    ...mapActions('announcement', ['create']),
    toggleDialogVisible(visible) {
      this.dialogVisible = visible;
    },
    closeDialog() {
      if (this.$refs['form']) {
        this.$refs['form'].resetFields();
      }
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.create(this.form).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.toggleDialogVisible(false);
            this.$emit('onCreated');
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.announcement-form {
  margin-right: 100px;
}
.editor {
  height: 500px;
}
</style>
